var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ExpiringStorage } from '@oneaudi/stck-store';
import { getScsUrlPartsFromConfiguration } from '../../../hooks';
import { dynamicStylingHelper } from '../../utils';
import { SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_DARK } from '@oneaudi/unified-web-alpha-common';
const fillMarker = (fillColor) => {
    return `data:image/svg+xml;charset=UTF-8,%3Csvg width='44' height='43' viewBox='0 0 44 43' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M44 0H0V36H14.9289L22 43.0711L29.0711 36H44V0Z' fill='%23${fillColor}'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M29.816 14.344C30.824 13.48 32.12 13 33.56 13C36.872 13 39.56 15.688 39.56 19C39.56 22.312 36.872 25 33.464 25C32.072 25 30.728 24.472 29.72 23.656C28.712 24.52 27.416 25 25.976 25C24.584 25 23.24 24.472 22.232 23.656C21.224 24.52 19.928 25 18.488 25C17.096 25 15.752 24.472 14.744 23.656C13.736 24.52 12.44 25 11 25C7.688 25 5 22.312 5 19C5 15.688 7.688 13 11 13C12.392 13 13.736 13.48 14.792 14.344C15.8 13.48 17.096 13 18.536 13C19.928 13 21.272 13.48 22.28 14.344C23.288 13.48 24.584 13 26.024 13C27.464 13 28.808 13.48 29.816 14.344ZM10.952 14.344C8.408 14.344 6.344 16.456 6.344 19C6.344 21.544 8.408 23.656 10.952 23.656C12.008 23.656 13.016 23.32 13.784 22.696C13.016 21.688 12.536 20.392 12.536 19C12.536 17.608 13.016 16.312 13.784 15.304C12.968 14.68 12.008 14.344 10.952 14.344ZM15.704 22.696C16.472 21.688 16.952 20.392 16.952 19C16.952 17.608 16.472 16.312 15.704 15.304C16.472 14.68 17.48 14.344 18.536 14.344C19.592 14.344 20.552 14.68 21.368 15.304C20.6 16.312 20.12 17.608 20.12 19C20.12 20.392 20.6 21.688 21.368 22.696C20.6 23.32 19.592 23.656 18.536 23.656C17.432 23.656 16.472 23.272 15.704 22.696ZM24.488 19C24.488 20.392 24.008 21.688 23.24 22.696C24.008 23.272 24.968 23.656 26.072 23.656C27.128 23.656 28.136 23.32 28.904 22.696C28.136 21.688 27.656 20.392 27.656 19C27.656 17.608 28.136 16.312 28.904 15.304C28.088 14.68 27.128 14.344 26.072 14.344C25.016 14.344 24.008 14.68 23.24 15.304C24.008 16.312 24.488 17.608 24.488 19ZM30.728 22.696C31.544 23.32 32.504 23.656 33.56 23.656C36.152 23.656 38.216 21.544 38.168 19C38.168 16.408 36.104 14.344 33.56 14.344C32.504 14.344 31.496 14.68 30.728 15.304C31.496 16.312 31.976 17.608 31.976 19C31.976 20.392 31.496 21.688 30.728 22.696ZM14.744 21.688C14.216 20.92 13.88 20.008 13.88 19C13.88 17.992 14.216 17.08 14.744 16.312C15.272 17.08 15.608 17.992 15.608 19C15.608 20.008 15.272 20.92 14.744 21.688ZM21.416 19C21.416 20.008 21.752 20.92 22.28 21.688C22.808 20.92 23.144 20.008 23.144 19C23.144 17.992 22.808 17.08 22.28 16.312C21.752 17.08 21.416 17.992 21.416 19ZM29.816 21.688C29.288 20.92 28.952 20.008 28.952 19C28.952 17.992 29.288 17.08 29.816 16.312C30.344 17.08 30.68 17.992 30.68 19C30.68 20.008 30.344 20.92 29.816 21.688Z' fill='white'/%3E%3C/svg%3E`;
};
const markerIconAlpha = (dealerStatus) => {
    let markerIcon;
    switch (dealerStatus) {
        case 'disabled':
            markerIcon = `<svg width="61" height="40" viewBox="0 0 61 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<foreignObject x="-40" y="-40" width="141" height="120"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_0_4104_77627_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="40" d="M45 0C53.8366 0 61 7.16344 61 16C61 24.8366 53.8366 32 45 32H37.915C34.647 36.5394 31.0089 39.9916 31 40C30.9948 39.995 27.3547 36.5417 24.085 32H16C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0H45Z" fill="#FCFCFD" fill-opacity="0.15"/>
<foreignObject x="-40" y="-40" width="141" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_1_4104_77627_clip_path);height:100%;width:100%"></div></foreignObject><g data-figma-bg-blur-radius="40">
<path d="M45.2145 22.2094C43.8311 22.2094 42.5558 21.7282 41.5361 20.9214C42.5709 19.5632 43.1903 17.855 43.1903 16C43.1903 14.1451 42.5709 12.437 41.5361 11.0786C42.5558 10.272 43.8311 9.79056 45.2145 9.79056C48.5466 9.79056 51.2575 12.5762 51.2575 16C51.2575 19.424 48.5466 22.2094 45.2145 22.2094ZM31.7262 20.9214C32.7612 19.5632 33.3806 17.855 33.3806 16C33.3806 14.1451 32.7612 12.437 31.7264 11.0786C32.746 10.272 34.0215 9.79056 35.4048 9.79056C36.7883 9.79056 38.0636 10.272 39.0833 11.0786C38.0485 12.437 37.4291 14.1451 37.4291 16C37.4291 17.855 38.0485 19.5632 39.0833 20.9214C38.0636 21.7282 36.7883 22.2094 35.4048 22.2094C34.0215 22.2094 32.7459 21.7282 31.7262 20.9214ZM21.9165 20.9214C22.9515 19.5632 23.5709 17.855 23.5709 16C23.5709 14.1451 22.9515 12.437 21.9167 11.0786C22.9363 10.272 24.2118 9.79056 25.5952 9.79056C26.9785 9.79056 28.254 10.272 29.2736 11.0786C28.2388 12.437 27.6194 14.1451 27.6194 16C27.6194 17.855 28.2388 19.5632 29.2736 20.9214C28.254 21.7282 26.9785 22.2094 25.5952 22.2094C24.2118 22.2094 22.9363 21.7282 21.9165 20.9214ZM9.74254 16C9.74254 12.5762 12.4534 9.79056 15.7855 9.79056C17.1688 9.79056 18.4444 10.272 19.4639 11.0786C18.4291 12.437 17.8097 14.1451 17.8097 16C17.8097 17.855 18.4291 19.5632 19.4639 20.9214C18.4444 21.7282 17.1688 22.2094 15.7855 22.2094C12.4534 22.2094 9.74254 19.424 9.74254 16ZM20.6903 19.6203C19.9751 18.6003 19.5522 17.3504 19.5522 16C19.5522 14.6498 19.9751 13.3997 20.6903 12.3797C21.4055 13.3997 21.8284 14.6498 21.8284 16C21.8284 17.3504 21.4055 18.6003 20.6903 19.6203ZM30.5 19.6203C29.7848 18.6003 29.3619 17.3504 29.3619 16C29.3619 14.6498 29.7848 13.3997 30.5 12.3797C31.2152 13.3997 31.6381 14.6498 31.6381 16C31.6381 17.3504 31.2152 18.6003 30.5 19.6203ZM40.3097 19.6203C39.5945 18.6003 39.1716 17.3504 39.1716 16C39.1716 14.6498 39.5945 13.3997 40.3097 12.3797C41.0249 13.3997 41.4478 14.6498 41.4478 16C41.4478 17.3504 41.0249 18.6003 40.3097 19.6203ZM45.2145 8C43.3566 8 41.6494 8.67312 40.3097 9.79312C38.97 8.67312 37.2628 8 35.4048 8C33.5469 8 31.8397 8.67312 30.5 9.79312C29.1603 8.67312 27.4529 8 25.5952 8C23.7372 8 22.03 8.67312 20.6903 9.79312C19.3506 8.67312 17.6432 8 15.7855 8C11.4926 8 8 11.5888 8 16C8 20.4114 11.4926 24 15.7855 24C17.6432 24 19.3506 23.327 20.6903 22.2069C22.03 23.327 23.7372 24 25.5952 24C27.4529 24 29.1603 23.327 30.5 22.2069C31.8397 23.327 33.5469 24 35.4048 24C37.2628 24 38.97 23.327 40.3097 22.2069C41.6494 23.327 43.3566 24 45.2145 24C49.5074 24 53 20.4114 53 16C53 11.5888 49.5074 8 45.2145 8Z" fill="#020203"/>
</g>
<defs>
<clipPath id="bgblur_0_4104_77627_clip_path" transform="translate(40 40)"><path d="M45 0C53.8366 0 61 7.16344 61 16C61 24.8366 53.8366 32 45 32H37.915C34.647 36.5394 31.0089 39.9916 31 40C30.9948 39.995 27.3547 36.5417 24.085 32H16C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0H45Z"/>
</clipPath><clipPath id="bgblur_1_4104_77627_clip_path" transform="translate(40 40)"><path d="M0 16C0 7.16344 7.16344 0 16 0H45C53.8366 0 61 7.16344 61 16V16C61 24.8366 53.8366 32 45 32H16C7.16344 32 0 24.8366 0 16V16Z"/>
</clipPath></defs>
</svg>
`;
            break;
        case 'unchecked':
            markerIcon = `<svg width="61" height="40" viewBox="0 0 61 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<foreignObject x="-21" y="-32" width="104" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_0_4104_77559_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="40" d="M43 20C43 28.6274 31 40 31 40C31 40 19 28.6274 19 20C19 13.3726 24.3726 8.00002 31 8.00002C37.6274 8.00002 43 13.3726 43 20Z" fill="url(#paint0_linear_4104_77559)"/>
<foreignObject x="-40" y="-40" width="141" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_1_4104_77559_clip_path);height:100%;width:100%"></div></foreignObject><g data-figma-bg-blur-radius="40">
<path d="M0 16C0 7.16344 7.16344 0 16 0H45C53.8366 0 61 7.16344 61 16C61 24.8366 53.8366 32 45 32H16C7.16344 32 0 24.8366 0 16Z" fill="url(#paint1_linear_4104_77559)"/>
<path d="M45.2145 22.2094C43.8311 22.2094 42.5558 21.7282 41.5361 20.9214C42.5709 19.5632 43.1903 17.855 43.1903 16C43.1903 14.1451 42.5709 12.437 41.5361 11.0786C42.5558 10.272 43.8311 9.79056 45.2145 9.79056C48.5466 9.79056 51.2575 12.5762 51.2575 16C51.2575 19.424 48.5466 22.2094 45.2145 22.2094ZM31.7262 20.9214C32.7612 19.5632 33.3806 17.855 33.3806 16C33.3806 14.1451 32.7612 12.437 31.7264 11.0786C32.746 10.272 34.0215 9.79056 35.4048 9.79056C36.7883 9.79056 38.0636 10.272 39.0833 11.0786C38.0485 12.437 37.4291 14.1451 37.4291 16C37.4291 17.855 38.0485 19.5632 39.0833 20.9214C38.0636 21.7282 36.7883 22.2094 35.4048 22.2094C34.0215 22.2094 32.7459 21.7282 31.7262 20.9214ZM21.9165 20.9214C22.9515 19.5632 23.5709 17.855 23.5709 16C23.5709 14.1451 22.9515 12.437 21.9167 11.0786C22.9363 10.272 24.2118 9.79056 25.5952 9.79056C26.9785 9.79056 28.254 10.272 29.2736 11.0786C28.2388 12.437 27.6194 14.1451 27.6194 16C27.6194 17.855 28.2388 19.5632 29.2736 20.9214C28.254 21.7282 26.9785 22.2094 25.5952 22.2094C24.2118 22.2094 22.9363 21.7282 21.9165 20.9214ZM9.74254 16C9.74254 12.5762 12.4534 9.79056 15.7855 9.79056C17.1688 9.79056 18.4444 10.272 19.4639 11.0786C18.4291 12.437 17.8097 14.1451 17.8097 16C17.8097 17.855 18.4291 19.5632 19.4639 20.9214C18.4444 21.7282 17.1688 22.2094 15.7855 22.2094C12.4534 22.2094 9.74254 19.424 9.74254 16ZM20.6903 19.6203C19.9751 18.6003 19.5522 17.3504 19.5522 16C19.5522 14.6498 19.9751 13.3997 20.6903 12.3797C21.4055 13.3997 21.8284 14.6498 21.8284 16C21.8284 17.3504 21.4055 18.6003 20.6903 19.6203ZM30.5 19.6203C29.7848 18.6003 29.3619 17.3504 29.3619 16C29.3619 14.6498 29.7848 13.3997 30.5 12.3797C31.2152 13.3997 31.6381 14.6498 31.6381 16C31.6381 17.3504 31.2152 18.6003 30.5 19.6203ZM40.3097 19.6203C39.5945 18.6003 39.1716 17.3504 39.1716 16C39.1716 14.6498 39.5945 13.3997 40.3097 12.3797C41.0249 13.3997 41.4478 14.6498 41.4478 16C41.4478 17.3504 41.0249 18.6003 40.3097 19.6203ZM45.2145 8C43.3566 8 41.6494 8.67312 40.3097 9.79312C38.97 8.67312 37.2628 8 35.4048 8C33.5469 8 31.8397 8.67312 30.5 9.79312C29.1603 8.67312 27.4529 8 25.5952 8C23.7372 8 22.03 8.67312 20.6903 9.79312C19.3506 8.67312 17.6432 8 15.7855 8C11.4926 8 8 11.5888 8 16C8 20.4114 11.4926 24 15.7855 24C17.6432 24 19.3506 23.327 20.6903 22.2069C22.03 23.327 23.7372 24 25.5952 24C27.4529 24 29.1603 23.327 30.5 22.2069C31.8397 23.327 33.5469 24 35.4048 24C37.2628 24 38.97 23.327 40.3097 22.2069C41.6494 23.327 43.3566 24 45.2145 24C49.5074 24 53 20.4114 53 16C53 11.5888 49.5074 8 45.2145 8Z" fill="#020203"/>
</g>
<defs>
<clipPath id="bgblur_0_4104_77559_clip_path" transform="translate(21 32)"><path d="M43 20C43 28.6274 31 40 31 40C31 40 19 28.6274 19 20C19 13.3726 24.3726 8.00002 31 8.00002C37.6274 8.00002 43 13.3726 43 20Z"/>
</clipPath><clipPath id="bgblur_1_4104_77559_clip_path" transform="translate(40 40)"><path d="M0 16C0 7.16344 7.16344 0 16 0H45C53.8366 0 61 7.16344 61 16C61 24.8366 53.8366 32 45 32H16C7.16344 32 0 24.8366 0 16Z"/>
</clipPath><linearGradient id="paint0_linear_4104_77559" x1="19" y1="8.54898" x2="49.4227" y2="30.5831" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#E2E4E9"/>
</linearGradient>
<linearGradient id="paint1_linear_4104_77559" x1="5.44204e-07" y1="0.548979" x2="26.8612" y2="49.9962" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#E2E4E9"/>
</linearGradient>
</defs>
</svg>
`;
            break;
        case 'checked':
            markerIcon = `<svg width="81" height="40" viewBox="0 0 81 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<foreignObject x="-11" y="-32" width="104" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_0_4107_77714_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="40" d="M53 20C53 28.6274 41 40 41 40C41 40 29 28.6274 29 20C29 13.3726 34.3726 8.00002 41 8.00002C47.6274 8.00002 53 13.3726 53 20Z" fill="url(#paint0_linear_4107_77714)"/>
<foreignObject x="-40" y="-40" width="161" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_1_4107_77714_clip_path);height:100%;width:100%"></div></foreignObject><g data-figma-bg-blur-radius="40">
<path d="M0 16C0 7.16344 7.16344 0 16 0H65C73.8366 0 81 7.16344 81 16C81 24.8366 73.8366 32 65 32H16C7.16344 32 0 24.8366 0 16Z" fill="url(#paint1_linear_4107_77714)"/>
<path d="M9.34375 16.1484L13.5977 20.2617L21.6172 10.3008" stroke="black" stroke-width="1.5"/>
<path d="M67.2145 22.2094C65.8311 22.2094 64.5558 21.7282 63.5361 20.9214C64.5709 19.5632 65.1903 17.855 65.1903 16C65.1903 14.1451 64.5709 12.437 63.5361 11.0786C64.5558 10.272 65.8311 9.79056 67.2145 9.79056C70.5466 9.79056 73.2575 12.5762 73.2575 16C73.2575 19.424 70.5466 22.2094 67.2145 22.2094ZM53.7262 20.9214C54.7612 19.5632 55.3806 17.855 55.3806 16C55.3806 14.1451 54.7612 12.437 53.7264 11.0786C54.746 10.272 56.0215 9.79056 57.4048 9.79056C58.7883 9.79056 60.0636 10.272 61.0833 11.0786C60.0485 12.437 59.4291 14.1451 59.4291 16C59.4291 17.855 60.0485 19.5632 61.0833 20.9214C60.0636 21.7282 58.7883 22.2094 57.4048 22.2094C56.0215 22.2094 54.7459 21.7282 53.7262 20.9214ZM43.9165 20.9214C44.9515 19.5632 45.5709 17.855 45.5709 16C45.5709 14.1451 44.9515 12.437 43.9167 11.0786C44.9363 10.272 46.2118 9.79056 47.5952 9.79056C48.9785 9.79056 50.254 10.272 51.2736 11.0786C50.2388 12.437 49.6194 14.1451 49.6194 16C49.6194 17.855 50.2388 19.5632 51.2736 20.9214C50.254 21.7282 48.9785 22.2094 47.5952 22.2094C46.2118 22.2094 44.9363 21.7282 43.9165 20.9214ZM31.7425 16C31.7425 12.5762 34.4534 9.79056 37.7855 9.79056C39.1688 9.79056 40.4444 10.272 41.4639 11.0786C40.4291 12.437 39.8097 14.1451 39.8097 16C39.8097 17.855 40.4291 19.5632 41.4639 20.9214C40.4444 21.7282 39.1688 22.2094 37.7855 22.2094C34.4534 22.2094 31.7425 19.424 31.7425 16ZM42.6903 19.6203C41.9751 18.6003 41.5522 17.3504 41.5522 16C41.5522 14.6498 41.9751 13.3997 42.6903 12.3797C43.4055 13.3997 43.8284 14.6498 43.8284 16C43.8284 17.3504 43.4055 18.6003 42.6903 19.6203ZM52.5 19.6203C51.7848 18.6003 51.3619 17.3504 51.3619 16C51.3619 14.6498 51.7848 13.3997 52.5 12.3797C53.2152 13.3997 53.6381 14.6498 53.6381 16C53.6381 17.3504 53.2152 18.6003 52.5 19.6203ZM62.3097 19.6203C61.5945 18.6003 61.1716 17.3504 61.1716 16C61.1716 14.6498 61.5945 13.3997 62.3097 12.3797C63.0249 13.3997 63.4478 14.6498 63.4478 16C63.4478 17.3504 63.0249 18.6003 62.3097 19.6203ZM67.2145 8C65.3566 8 63.6494 8.67312 62.3097 9.79312C60.97 8.67312 59.2628 8 57.4048 8C55.5469 8 53.8397 8.67312 52.5 9.79312C51.1603 8.67312 49.4529 8 47.5952 8C45.7372 8 44.03 8.67312 42.6903 9.79312C41.3506 8.67312 39.6432 8 37.7855 8C33.4926 8 30 11.5888 30 16C30 20.4114 33.4926 24 37.7855 24C39.6432 24 41.3506 23.327 42.6903 22.2069C44.03 23.327 45.7372 24 47.5952 24C49.4529 24 51.1603 23.327 52.5 22.2069C53.8397 23.327 55.5469 24 57.4048 24C59.2628 24 60.97 23.327 62.3097 22.2069C63.6494 23.327 65.3566 24 67.2145 24C71.5074 24 75 20.4114 75 16C75 11.5888 71.5074 8 67.2145 8Z" fill="#020203"/>
</g>
<defs>
<clipPath id="bgblur_0_4107_77714_clip_path" transform="translate(11 32)"><path d="M53 20C53 28.6274 41 40 41 40C41 40 29 28.6274 29 20C29 13.3726 34.3726 8.00002 41 8.00002C47.6274 8.00002 53 13.3726 53 20Z"/>
</clipPath><clipPath id="bgblur_1_4107_77714_clip_path" transform="translate(40 40)"><path d="M0 16C0 7.16344 7.16344 0 16 0H65C73.8366 0 81 7.16344 81 16C81 24.8366 73.8366 32 65 32H16C7.16344 32 0 24.8366 0 16Z"/>
</clipPath><linearGradient id="paint0_linear_4107_77714" x1="29" y1="8.54898" x2="59.4227" y2="30.5831" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#E2E4E9"/>
</linearGradient>
<linearGradient id="paint1_linear_4107_77714" x1="7.22632e-07" y1="0.548979" x2="22.4423" y2="55.4069" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#E2E4E9"/>
</linearGradient>
</defs>
</svg>
`;
            break;
        case 'focused':
            markerIcon = `<svg width="81" height="40" viewBox="0 0 81 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<foreignObject x="-11" y="-32" width="104" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_0_4107_78194_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="40" d="M53 20C53 28.6274 41 40 41 40C41 40 29 28.6274 29 20C29 13.3726 34.3726 8.00002 41 8.00002C47.6274 8.00002 53 13.3726 53 20Z" fill="#89FF89"/>
<foreignObject x="-40" y="-40" width="161" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_1_4107_78194_clip_path);height:100%;width:100%"></div></foreignObject><g data-figma-bg-blur-radius="40">
<path d="M0 16C0 7.16344 7.16344 0 16 0H65C73.8366 0 81 7.16344 81 16C81 24.8366 73.8366 32 65 32H16C7.16344 32 0 24.8366 0 16Z" fill="#89FF89"/>
<path d="M9.34375 16.1484L13.5977 20.2617L21.6172 10.3008" stroke="black" stroke-width="1.5"/>
<path d="M67.2145 22.2094C65.8311 22.2094 64.5558 21.7282 63.5361 20.9214C64.5709 19.5632 65.1903 17.855 65.1903 16C65.1903 14.1451 64.5709 12.437 63.5361 11.0786C64.5558 10.272 65.8311 9.79056 67.2145 9.79056C70.5466 9.79056 73.2575 12.5762 73.2575 16C73.2575 19.424 70.5466 22.2094 67.2145 22.2094ZM53.7262 20.9214C54.7612 19.5632 55.3806 17.855 55.3806 16C55.3806 14.1451 54.7612 12.437 53.7264 11.0786C54.746 10.272 56.0215 9.79056 57.4048 9.79056C58.7883 9.79056 60.0636 10.272 61.0833 11.0786C60.0485 12.437 59.4291 14.1451 59.4291 16C59.4291 17.855 60.0485 19.5632 61.0833 20.9214C60.0636 21.7282 58.7883 22.2094 57.4048 22.2094C56.0215 22.2094 54.7459 21.7282 53.7262 20.9214ZM43.9165 20.9214C44.9515 19.5632 45.5709 17.855 45.5709 16C45.5709 14.1451 44.9515 12.437 43.9167 11.0786C44.9363 10.272 46.2118 9.79056 47.5952 9.79056C48.9785 9.79056 50.254 10.272 51.2736 11.0786C50.2388 12.437 49.6194 14.1451 49.6194 16C49.6194 17.855 50.2388 19.5632 51.2736 20.9214C50.254 21.7282 48.9785 22.2094 47.5952 22.2094C46.2118 22.2094 44.9363 21.7282 43.9165 20.9214ZM31.7425 16C31.7425 12.5762 34.4534 9.79056 37.7855 9.79056C39.1688 9.79056 40.4444 10.272 41.4639 11.0786C40.4291 12.437 39.8097 14.1451 39.8097 16C39.8097 17.855 40.4291 19.5632 41.4639 20.9214C40.4444 21.7282 39.1688 22.2094 37.7855 22.2094C34.4534 22.2094 31.7425 19.424 31.7425 16ZM42.6903 19.6203C41.9751 18.6003 41.5522 17.3504 41.5522 16C41.5522 14.6498 41.9751 13.3997 42.6903 12.3797C43.4055 13.3997 43.8284 14.6498 43.8284 16C43.8284 17.3504 43.4055 18.6003 42.6903 19.6203ZM52.5 19.6203C51.7848 18.6003 51.3619 17.3504 51.3619 16C51.3619 14.6498 51.7848 13.3997 52.5 12.3797C53.2152 13.3997 53.6381 14.6498 53.6381 16C53.6381 17.3504 53.2152 18.6003 52.5 19.6203ZM62.3097 19.6203C61.5945 18.6003 61.1716 17.3504 61.1716 16C61.1716 14.6498 61.5945 13.3997 62.3097 12.3797C63.0249 13.3997 63.4478 14.6498 63.4478 16C63.4478 17.3504 63.0249 18.6003 62.3097 19.6203ZM67.2145 8C65.3566 8 63.6494 8.67312 62.3097 9.79312C60.97 8.67312 59.2628 8 57.4048 8C55.5469 8 53.8397 8.67312 52.5 9.79312C51.1603 8.67312 49.4529 8 47.5952 8C45.7372 8 44.03 8.67312 42.6903 9.79312C41.3506 8.67312 39.6432 8 37.7855 8C33.4926 8 30 11.5888 30 16C30 20.4114 33.4926 24 37.7855 24C39.6432 24 41.3506 23.327 42.6903 22.2069C44.03 23.327 45.7372 24 47.5952 24C49.4529 24 51.1603 23.327 52.5 22.2069C53.8397 23.327 55.5469 24 57.4048 24C59.2628 24 60.97 23.327 62.3097 22.2069C63.6494 23.327 65.3566 24 67.2145 24C71.5074 24 75 20.4114 75 16C75 11.5888 71.5074 8 67.2145 8Z" fill="#020203"/>
</g>
<defs>
<clipPath id="bgblur_0_4107_78194_clip_path" transform="translate(11 32)"><path d="M53 20C53 28.6274 41 40 41 40C41 40 29 28.6274 29 20C29 13.3726 34.3726 8.00002 41 8.00002C47.6274 8.00002 53 13.3726 53 20Z"/>
</clipPath><clipPath id="bgblur_1_4107_78194_clip_path" transform="translate(40 40)"><path d="M0 16C0 7.16344 7.16344 0 16 0H65C73.8366 0 81 7.16344 81 16C81 24.8366 73.8366 32 65 32H16C7.16344 32 0 24.8366 0 16Z"/>
</clipPath></defs>
</svg>
`;
            break;
        default:
            markerIcon = `<svg width="61" height="40" viewBox="0 0 61 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<foreignObject x="-21" y="-32" width="104" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_0_4104_77559_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="40" d="M43 20C43 28.6274 31 40 31 40C31 40 19 28.6274 19 20C19 13.3726 24.3726 8.00002 31 8.00002C37.6274 8.00002 43 13.3726 43 20Z" fill="url(#paint0_linear_4104_77559)"/>
<foreignObject x="-40" y="-40" width="141" height="112"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(20px);clip-path:url(#bgblur_1_4104_77559_clip_path);height:100%;width:100%"></div></foreignObject><g data-figma-bg-blur-radius="40">
<path d="M0 16C0 7.16344 7.16344 0 16 0H45C53.8366 0 61 7.16344 61 16C61 24.8366 53.8366 32 45 32H16C7.16344 32 0 24.8366 0 16Z" fill="url(#paint1_linear_4104_77559)"/>
<path d="M45.2145 22.2094C43.8311 22.2094 42.5558 21.7282 41.5361 20.9214C42.5709 19.5632 43.1903 17.855 43.1903 16C43.1903 14.1451 42.5709 12.437 41.5361 11.0786C42.5558 10.272 43.8311 9.79056 45.2145 9.79056C48.5466 9.79056 51.2575 12.5762 51.2575 16C51.2575 19.424 48.5466 22.2094 45.2145 22.2094ZM31.7262 20.9214C32.7612 19.5632 33.3806 17.855 33.3806 16C33.3806 14.1451 32.7612 12.437 31.7264 11.0786C32.746 10.272 34.0215 9.79056 35.4048 9.79056C36.7883 9.79056 38.0636 10.272 39.0833 11.0786C38.0485 12.437 37.4291 14.1451 37.4291 16C37.4291 17.855 38.0485 19.5632 39.0833 20.9214C38.0636 21.7282 36.7883 22.2094 35.4048 22.2094C34.0215 22.2094 32.7459 21.7282 31.7262 20.9214ZM21.9165 20.9214C22.9515 19.5632 23.5709 17.855 23.5709 16C23.5709 14.1451 22.9515 12.437 21.9167 11.0786C22.9363 10.272 24.2118 9.79056 25.5952 9.79056C26.9785 9.79056 28.254 10.272 29.2736 11.0786C28.2388 12.437 27.6194 14.1451 27.6194 16C27.6194 17.855 28.2388 19.5632 29.2736 20.9214C28.254 21.7282 26.9785 22.2094 25.5952 22.2094C24.2118 22.2094 22.9363 21.7282 21.9165 20.9214ZM9.74254 16C9.74254 12.5762 12.4534 9.79056 15.7855 9.79056C17.1688 9.79056 18.4444 10.272 19.4639 11.0786C18.4291 12.437 17.8097 14.1451 17.8097 16C17.8097 17.855 18.4291 19.5632 19.4639 20.9214C18.4444 21.7282 17.1688 22.2094 15.7855 22.2094C12.4534 22.2094 9.74254 19.424 9.74254 16ZM20.6903 19.6203C19.9751 18.6003 19.5522 17.3504 19.5522 16C19.5522 14.6498 19.9751 13.3997 20.6903 12.3797C21.4055 13.3997 21.8284 14.6498 21.8284 16C21.8284 17.3504 21.4055 18.6003 20.6903 19.6203ZM30.5 19.6203C29.7848 18.6003 29.3619 17.3504 29.3619 16C29.3619 14.6498 29.7848 13.3997 30.5 12.3797C31.2152 13.3997 31.6381 14.6498 31.6381 16C31.6381 17.3504 31.2152 18.6003 30.5 19.6203ZM40.3097 19.6203C39.5945 18.6003 39.1716 17.3504 39.1716 16C39.1716 14.6498 39.5945 13.3997 40.3097 12.3797C41.0249 13.3997 41.4478 14.6498 41.4478 16C41.4478 17.3504 41.0249 18.6003 40.3097 19.6203ZM45.2145 8C43.3566 8 41.6494 8.67312 40.3097 9.79312C38.97 8.67312 37.2628 8 35.4048 8C33.5469 8 31.8397 8.67312 30.5 9.79312C29.1603 8.67312 27.4529 8 25.5952 8C23.7372 8 22.03 8.67312 20.6903 9.79312C19.3506 8.67312 17.6432 8 15.7855 8C11.4926 8 8 11.5888 8 16C8 20.4114 11.4926 24 15.7855 24C17.6432 24 19.3506 23.327 20.6903 22.2069C22.03 23.327 23.7372 24 25.5952 24C27.4529 24 29.1603 23.327 30.5 22.2069C31.8397 23.327 33.5469 24 35.4048 24C37.2628 24 38.97 23.327 40.3097 22.2069C41.6494 23.327 43.3566 24 45.2145 24C49.5074 24 53 20.4114 53 16C53 11.5888 49.5074 8 45.2145 8Z" fill="#020203"/>
</g>
<defs>
<clipPath id="bgblur_0_4104_77559_clip_path" transform="translate(21 32)"><path d="M43 20C43 28.6274 31 40 31 40C31 40 19 28.6274 19 20C19 13.3726 24.3726 8.00002 31 8.00002C37.6274 8.00002 43 13.3726 43 20Z"/>
</clipPath><clipPath id="bgblur_1_4104_77559_clip_path" transform="translate(40 40)"><path d="M0 16C0 7.16344 7.16344 0 16 0H45C53.8366 0 61 7.16344 61 16C61 24.8366 53.8366 32 45 32H16C7.16344 32 0 24.8366 0 16Z"/>
</clipPath><linearGradient id="paint0_linear_4104_77559" x1="19" y1="8.54898" x2="49.4227" y2="30.5831" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#E2E4E9"/>
</linearGradient>
<linearGradient id="paint1_linear_4104_77559" x1="5.44204e-07" y1="0.548979" x2="26.8612" y2="49.9962" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#E2E4E9"/>
</linearGradient>
</defs>
</svg>`;
            break;
    }
    const encodedMarkerIcon = encodeURIComponent(markerIcon)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22');
    const dataUri = `data:image/svg+xml;charset=UTF-8,${encodedMarkerIcon}`;
    return dataUri;
};
export const getMarkerIcon = (dealerStatus) => {
    let markerIcon;
    switch (dealerStatus) {
        case 'disabled':
            markerIcon = dynamicStylingHelper(fillMarker('b3b3b3'), markerIconAlpha('disabled'));
            break;
        case 'unchecked':
            markerIcon = dynamicStylingHelper(fillMarker('666666'), markerIconAlpha('unchecked'));
            break;
        case 'checked':
            markerIcon = dynamicStylingHelper(fillMarker('000000'), markerIconAlpha('checked'));
            break;
        case 'focused':
            markerIcon = dynamicStylingHelper(fillMarker('F50537'), markerIconAlpha('focused'));
            break;
        default:
            markerIcon = dynamicStylingHelper(fillMarker('666666'), markerIconAlpha('unchecked'));
            break;
    }
    return markerIcon;
};
export const getRadiusCircleIcon = (map, lat, long, radius, defaultRadius, zeroDealersFound) => {
    return new google.maps.Circle({
        strokeWeight: 0,
        fillColor: '#B3B3B3',
        fillOpacity: zeroDealersFound ? 0 : 0.4,
        center: { lat, lng: long },
        map,
        clickable: false,
        radius: Number(radius || defaultRadius) * 1000,
    });
};
export const getMarkerTitle = (markerRef, status, markerLabelPrefixes) => {
    var _a;
    const oldMarkerTitle = markerRef.title;
    const cleanMarkerTitle = oldMarkerTitle
        .replace(markerLabelPrefixes.checked, '')
        .replace(markerLabelPrefixes.focused, '')
        .replace(markerLabelPrefixes.unchecked, '')
        .replace(markerLabelPrefixes.disabled, '');
    const newMarkerTitle = (_a = markerLabelPrefixes[status]) === null || _a === void 0 ? void 0 : _a.concat(' ', cleanMarkerTitle);
    return newMarkerTitle;
};
export const updateMarkerIcons = (dealersList, markersRef, markerLabelPrefixes) => {
    dealersList.forEach((item) => {
        var _a;
        const itemMarkerRef = (_a = markersRef === null || markersRef === void 0 ? void 0 : markersRef.find((marker) => {
            return marker.dealerId === item.dealerId;
        })) === null || _a === void 0 ? void 0 : _a.markerRef;
        if (itemMarkerRef === null || itemMarkerRef === void 0 ? void 0 : itemMarkerRef.content) {
            const itemMarkerRefHTMLElement = itemMarkerRef.content;
            const markerParent = itemMarkerRefHTMLElement === null || itemMarkerRefHTMLElement === void 0 ? void 0 : itemMarkerRefHTMLElement.closest('gmp-advanced-marker');
            const newMarkerImg = getMarkerIcon(item.status);
            itemMarkerRefHTMLElement.setAttribute('src', newMarkerImg);
            itemMarkerRef.title = getMarkerTitle(itemMarkerRef, item.status, markerLabelPrefixes);
            itemMarkerRefHTMLElement.classList.remove('marker--disabled');
            markerParent.classList.remove('marker--disabled');
            if (item.status === 'disabled') {
                itemMarkerRefHTMLElement.classList.add('marker--disabled');
                markerParent.classList.add('marker--disabled');
            }
        }
    });
};
export const moveMapToSearchedLatLong = (latLong, map) => {
    map === null || map === void 0 ? void 0 : map.fitBounds(latLong);
};
export const setDealerStatusToFocused = (condition) => {
    return condition;
};
export const setDealerStatus = (firstCondition, secondCondition) => {
    return firstCondition ? 'disabled' : secondCondition ? 'checked' : 'unchecked';
};
export const areSomeCarsAvailable = (dealersList, filterData) => {
    let carsAreAvailable = false;
    if (dealersList && filterData) {
        dealersList.forEach((item) => {
            var _a, _b, _c;
            const dealerFilterData = (_b = (_a = filterData.groups) === null || _a === void 0 ? void 0 : _a.dealers) === null || _b === void 0 ? void 0 : _b.members;
            const dealerCarsCount = ((_c = dealerFilterData === null || dealerFilterData === void 0 ? void 0 : dealerFilterData[`dealer.${item.id}`]) === null || _c === void 0 ? void 0 : _c.count) || 0;
            if (dealerCarsCount > 0) {
                carsAreAvailable = true;
            }
        });
    }
    return carsAreAvailable;
};
export const scrollDealerListItemToTop = (dealerItemsRef, dealerListRef, selectedDealer, dealersList) => {
    var _a, _b, _c;
    const foundDealerItem = dealerItemsRef.current.find((elem) => elem.dataset.dealerId === selectedDealer.dealerId);
    const currentDealerStatus = (_a = dealersList === null || dealersList === void 0 ? void 0 : dealersList.find((item) => {
        return item.dealerId === selectedDealer.dealerId;
    })) === null || _a === void 0 ? void 0 : _a.status;
    const newDealerStatusIsFocused = setDealerStatusToFocused(currentDealerStatus === 'unchecked');
    const dealerItemTop = foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.getBoundingClientRect().top;
    const dealerListTop = (_b = dealerListRef === null || dealerListRef === void 0 ? void 0 : dealerListRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top;
    if (dealerItemTop &&
        dealerListTop &&
        newDealerStatusIsFocused &&
        selectedDealer.source === 'marker') {
        (_c = dealerListRef === null || dealerListRef === void 0 ? void 0 : dealerListRef.current) === null || _c === void 0 ? void 0 : _c.scrollBy({
            top: dealerItemTop - dealerListTop,
        });
    }
};
export const createDealersData = (dealersListt, filterDealerData) => {
    return dealersListt.map((item) => {
        const foundDealerItem = filterDealerData[item.dealerId];
        return foundDealerItem
            ? Object.assign(Object.assign({}, item), { count: foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.count, status: setDealerStatusToFocused(item.status === 'focused' &&
                    (foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.count) > 0 &&
                    (foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.active) === true)
                    ? 'focused'
                    : setDealerStatus((foundDealerItem === null || foundDealerItem === void 0 ? void 0 : foundDealerItem.count) === 0, foundDealerItem.active) }) : Object.assign({}, item);
    });
};
export const doDealerDataDiffer = (incomingData, currentData) => {
    return JSON.stringify(incomingData) !== JSON.stringify(currentData);
};
export const setRadiusMarker = (previousRadiusMarker, setPreviousRadiusMarker, map, lat, long, radius, defaultRadius, zeroDealersFound) => {
    previousRadiusMarker === null || previousRadiusMarker === void 0 ? void 0 : previousRadiusMarker.setMap(null);
    setPreviousRadiusMarker(null);
    const circle = getRadiusCircleIcon(map, lat, long, radius, defaultRadius, zeroDealersFound);
    setPreviousRadiusMarker(circle);
    const circleLatLong = circle.getBounds();
    if (circleLatLong)
        moveMapToSearchedLatLong(circleLatLong, map);
};
export const removeRadiusMarker = (previousRadiusMarker, setPreviousRadiusMarker) => {
    previousRadiusMarker === null || previousRadiusMarker === void 0 ? void 0 : previousRadiusMarker.setMap(null);
    setPreviousRadiusMarker(null);
};
export const changeIconFormerlyFocusedMarker = (dealersList, markersRef, markerLabelPrefixes) => {
    var _a, _b;
    const prevFocusedMarkerId = (_a = dealersList.find((item) => {
        return item.status === 'focused';
    })) === null || _a === void 0 ? void 0 : _a.dealerId;
    const prevFocusedMarkerRef = (_b = markersRef.find((item) => {
        return item.dealerId === prevFocusedMarkerId;
    })) === null || _b === void 0 ? void 0 : _b.markerRef;
    if (prevFocusedMarkerRef === null || prevFocusedMarkerRef === void 0 ? void 0 : prevFocusedMarkerRef.content) {
        const prevFocusedMarkerRefHTMLElement = prevFocusedMarkerRef.content;
        const newMarkerImage = getMarkerIcon('checked');
        prevFocusedMarkerRefHTMLElement.setAttribute('src', newMarkerImage);
        const newMarkerTitle = getMarkerTitle(prevFocusedMarkerRef, 'checked', markerLabelPrefixes);
        prevFocusedMarkerRefHTMLElement.title = newMarkerTitle;
    }
};
export const changeIconNewSelectedMarker = (markersRef, selectedDealer, newDealerStatus, markerLabelPrefixes) => {
    var _a;
    const clickedMarkerRef = (_a = markersRef.find((item) => {
        return item.dealerId === selectedDealer.dealerId;
    })) === null || _a === void 0 ? void 0 : _a.markerRef;
    if (clickedMarkerRef === null || clickedMarkerRef === void 0 ? void 0 : clickedMarkerRef.content) {
        const clickedMarkerRefHTMLElement = clickedMarkerRef.content;
        clickedMarkerRef.title = getMarkerTitle(clickedMarkerRef, newDealerStatus, markerLabelPrefixes);
        const newMarkerImage = getMarkerIcon(newDealerStatus);
        clickedMarkerRefHTMLElement.setAttribute('src', newMarkerImage);
    }
};
export const updateLocationSearchInputLocalStorage = (localStorageIdentifier, keyToUpdate, valueToUpdate) => {
    if (!valueToUpdate)
        return;
    const localStorage = new ExpiringStorage(localStorageIdentifier, 30);
    const inputFromLocalStorage = localStorage.readEntry();
    if (inputFromLocalStorage) {
        inputFromLocalStorage[keyToUpdate] = valueToUpdate;
        localStorage.writeEntry(inputFromLocalStorage);
    }
    else {
        const inputDataObj = {};
        inputDataObj[keyToUpdate] = valueToUpdate;
        localStorage.writeEntry(inputDataObj);
    }
};
export const setAddressFromLatLngGeocoder = (position, inputRef, localStorageLocationSearchInputKey, setLocationInputValue, context, autocompleteRef) => {
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results) {
            const formattedAddress = results[0].formatted_address;
            const lastCommaIndex = formattedAddress.lastIndexOf(',');
            const addressWithoutCountry = lastCommaIndex > 0 ? formattedAddress.substring(0, lastCommaIndex) : formattedAddress;
            if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)
                inputRef.current.value = addressWithoutCountry;
            updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'inputName', addressWithoutCountry);
            if (setLocationInputValue && context) {
                setLocationInputValue(addressWithoutCountry);
                syncAutocompleteElementValue(autocompleteRef === null || autocompleteRef === void 0 ? void 0 : autocompleteRef.current, addressWithoutCountry);
                context.setSearchedCoords({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    autolocateMe: true,
                });
            }
            updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'placeId', results[0].place_id);
        }
    });
};
export const initializeInitialStateFromLocalStorage = (inputRef, inputDataFromLocalStorage, setRadius, setSearchedCoords, logger) => {
    inputRef.current.value = inputDataFromLocalStorage.inputName;
    setRadius(inputDataFromLocalStorage.radius);
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: inputDataFromLocalStorage.placeId }, (results, status) => {
        if (status === 'OK' && results) {
            setSearchedCoords({
                latitude: results[0].geometry.location.lat(),
                longitude: results[0].geometry.location.lng(),
            });
        }
        else {
            logger === null || logger === void 0 ? void 0 : logger.warn(`No placeId ${status} found`);
        }
    });
};
export const shouldBeUsedFilterDataWithoutClearingDealers = (changedRadius, firstAutocompleteSearch, hasSearchedLocationOnOverlayOpening) => {
    let useFilterDataWithoutClearingDealers = false;
    if ((changedRadius && !firstAutocompleteSearch) || hasSearchedLocationOnOverlayOpening) {
        useFilterDataWithoutClearingDealers = true;
    }
    return useFilterDataWithoutClearingDealers;
};
export const initializeMap = (mapRefNode, isMobile, locationFilterConfig_mapDarkThemeId, logger) => {
    const center = { lat: 54.526, lng: 15.2551 };
    const zoom = 2;
    return new google.maps.Map(mapRefNode, {
        center,
        zoom,
        mapTypeControl: false,
        streetViewControl: false,
        disableDefaultUI: false,
        zoomControl: !isMobile,
        scaleControl: false,
        scrollwheel: false,
        draggable: true,
        disableDoubleClickZoom: true,
        fullscreenControl: false,
        mapId: dynamicStylingHelper('MAP', (() => {
            if (!locationFilterConfig_mapDarkThemeId) {
                logger.error('Dark Theme mapId is not set!');
                return 'DARK_MAP';
            }
            return locationFilterConfig_mapDarkThemeId;
        })()),
        colorScheme: dynamicStylingHelper(google.maps.ColorScheme.LIGHT, google.maps.ColorScheme.DARK),
    });
};
export const syncAutocompleteElementValue = (autocomplete, value) => {
    var _a;
    if (!autocomplete) {
        return;
    }
    autocomplete.value = value;
    const shadowInput = (_a = autocomplete.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('input');
    if (shadowInput instanceof HTMLInputElement) {
        shadowInput.value = value;
    }
};
if (typeof window !== 'undefined' && !window.__gmpShadowPatched) {
    const orig = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function patchAttachShadow(init) {
        return orig.call(this, Object.assign(Object.assign({}, init), (this.localName === 'gmp-place-autocomplete' ? { mode: 'open' } : {})));
    };
    window.__gmpShadowPatched = true;
}
const SHADOW_DOM_CSS = `
  .full-window-autocomplete-dialog {
    background: linear-gradient(134deg, rgb(44, 52, 63) 0%, rgb(35, 42, 52) 100%);
    max-height: 100vh;
    max-height: 100dvh;
    overflow-y: auto;

    input {
      color: #ffffff !important;
      padding-left: 0px !important;
      &::placeholder {
        color: #ffffff !important;
        opacity: 0.7 !important;
      }
    }
  }
  .place-autocomplete-element-place-icon {
    display: none !important;
  }
  .clear-button {
    pointer-events: none !important;
    opacity: 0 !important;
    cursor: default !important;
  }
  .autocomplete-icon {
    display: none !important;
  }
  input {
    border: none !important;
    outline: none !important;
    font-family: inherit !important;
    padding-left: 50px !important;
    padding-right: 25px !important;

    &::placeholder {
      color: #ffffff !important;
      opacity: 0.7 !important;
    }

    &:disabled {
      cursor: not-allowed !important;
      &::placeholder {
      ${dynamicStylingHelper({
    alpha: `color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_DARK} !important;`,
})}
      }
    }
  }
  .place-autocomplete-element-place-details {
    color: #ffffff !important;
  }
  

  .dropdown {
    background: linear-gradient(180deg, hsla(216, 14%, 35%, 1) 0%, hsla(216, 16%, 30%, 1) 100%);
    padding-inline: 0;
    z-index: 100000;
    border-radius: 20px !important;
    border-top: 0px;
    max-height: 40vh;
    max-height: 40dvh;
    overflow-y: auto;
    position: fixed !important;
    top: var(--vtp-dropdown-top, auto) !important;
    left: var(--vtp-dropdown-left, auto) !important;
    width: var(--vtp-dropdown-width, 100%) !important;

    ul >li {
      cursor: pointer;
      border-bottom: 1px solid #a0a0a0 !important;
      padding-inline: 20px 16px !important;
      &:hover {
        background-color: hsla(216, 33%, 99%, 0.15) !important;
      }
      &:last-child {
        border-bottom: none !important;
      }
      .place-autocomplete-element-place-name {
        color:  #c7c7c7 !important;
      }
      .place-autocomplete-element-place-result--matched, .place-autocomplete-element-place-details {
        color: #ffffff !important;
      }
    }
  }
  .full-window-autocomplete-dialog[open] {
    position: fixed !important;
    top: var(--vtp-dialog-top, 0px) !important;
    left: 0px !important;
    width: 100vw !important;
    height: var(--vtp-dialog-height, 100dvh) !important;
    max-height: unset !important;
    max-width: unset !important;
    margin: 0 !important;
    z-index: 99999 !important;
    overflow: hidden !important;
  }
  .predictions-anchor {
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    touch-action: pan-y !important;
    flex: 1 1 auto !important;
    min-height: 0 !important;
  }
`;
const injectShadowStyles = (el) => {
    const shadow = el.shadowRoot;
    if (!shadow)
        return false;
    if (shadow.querySelector('[data-injected="gmp"]'))
        return true;
    const style = document.createElement('style');
    style.setAttribute('data-injected', 'gmp');
    style.textContent = SHADOW_DOM_CSS;
    shadow.appendChild(style);
    return true;
};
const applyContainingBlockFix = (autocompleteEl, trapEl, isMas) => {
    let rafId = null;
    const preventScroll = (e) => {
        const path = e.composedPath ? e.composedPath() : [];
        const inPredictions = path.some((n) => n.classList && n.classList.contains('predictions-anchor'));
        if (!inPredictions)
            e.preventDefault();
    };
    const updateOffset = () => {
        const top = trapEl && !isMas ? trapEl.getBoundingClientRect().top : 0;
        autocompleteEl.style.setProperty('--vtp-dialog-top', `${-top}px`);
    };
    const updateHeight = () => {
        let h = 0;
        if (typeof window !== 'undefined') {
            h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        }
        autocompleteEl.style.setProperty('--vtp-dialog-height', `${h}px`);
        updateOffset();
    };
    const trackOffset = () => {
        updateOffset();
        rafId = requestAnimationFrame(trackOffset);
    };
    const lockScroll = () => {
        var _a, _b;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('touchmove', preventScroll, { passive: false });
        if (typeof window !== 'undefined') {
            (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener('resize', updateHeight);
            (_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', updateOffset);
        }
        updateHeight();
        trackOffset();
    };
    const unlockScroll = () => {
        var _a, _b;
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        document.removeEventListener('touchmove', preventScroll);
        if (typeof window !== 'undefined') {
            (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.removeEventListener('resize', updateHeight);
            (_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.removeEventListener('scroll', updateOffset);
        }
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
        autocompleteEl.style.removeProperty('--vtp-dialog-top');
        autocompleteEl.style.removeProperty('--vtp-dialog-height');
    };
    const shadow = autocompleteEl.shadowRoot;
    if (!shadow)
        return () => { };
    const updateDropdownPosition = () => {
        const rect = autocompleteEl.getBoundingClientRect();
        if (!isMas) {
            autocompleteEl.style.setProperty('--vtp-dropdown-top', `${rect.bottom}px`);
            autocompleteEl.style.setProperty('--vtp-dropdown-left', `${rect.left}px`);
        }
        autocompleteEl.style.setProperty('--vtp-dropdown-width', `${rect.width}px`);
    };
    let dropdownRafId = null;
    const startDropdownTracking = () => {
        if (dropdownRafId !== null)
            return;
        const tick = () => {
            updateDropdownPosition();
            dropdownRafId = requestAnimationFrame(tick);
        };
        tick();
    };
    const stopDropdownTracking = () => {
        if (dropdownRafId !== null) {
            cancelAnimationFrame(dropdownRafId);
            dropdownRafId = null;
        }
        autocompleteEl.style.removeProperty('--vtp-dropdown-top');
        autocompleteEl.style.removeProperty('--vtp-dropdown-left');
        autocompleteEl.style.removeProperty('--vtp-dropdown-width');
    };
    const moDropdown = new MutationObserver(() => {
        const dialog = shadow.querySelector('.full-window-autocomplete-dialog');
        const isFullWindowOpen = !!(dialog === null || dialog === void 0 ? void 0 : dialog.open);
        const dropdown = shadow.querySelector('.dropdown');
        if (dropdown && !isFullWindowOpen) {
            startDropdownTracking();
        }
        else {
            stopDropdownTracking();
        }
    });
    moDropdown.observe(shadow, { attributes: true, subtree: true, childList: true });
    const mo = new MutationObserver(() => {
        const dialog = shadow.querySelector('.full-window-autocomplete-dialog');
        if (!dialog)
            return;
        if (dialog.open) {
            lockScroll();
        }
        else {
            unlockScroll();
        }
    });
    mo.observe(shadow, { attributes: true, subtree: true, childList: true });
    return () => {
        moDropdown.disconnect();
        stopDropdownTracking();
        mo.disconnect();
        unlockScroll();
    };
};
export const initializeAutocomplete = (country, inputRef, localStorageLocationSearchInputKey, setSearchedCoords, autocompleteRef, isMas, logger, setInputValue, onInputValueChange, shouldDisable) => {
    var _a, _b, _c;
    if (!((_b = (_a = google === null || google === void 0 ? void 0 : google.maps) === null || _a === void 0 ? void 0 : _a.places) === null || _b === void 0 ? void 0 : _b.PlaceAutocompleteElement)) {
        return logger === null || logger === void 0 ? void 0 : logger.error('[initializeAutocomplete] PlaceAutocompleteElement not loaded or not ready!');
    }
    if (!inputRef.current) {
        return logger === null || logger === void 0 ? void 0 : logger.error('[initializeAutocomplete] inputRef is null or not mounted.');
    }
    const options = {
        includedRegionCodes: [country],
        includedPrimaryTypes: ['locality', 'postal_code', 'sublocality', 'sublocality_level_1'],
    };
    const autocomplete = new google.maps.places.PlaceAutocompleteElement(options);
    const autocompleteElement = autocomplete;
    autocompleteElement.setAttribute('for', inputRef.current.id);
    autocompleteElement.setAttribute('id', inputRef.current.id);
    autocompleteElement.className = inputRef.current.className;
    autocompleteElement.style.cssText = inputRef.current.style.cssText;
    if (shouldDisable) {
        autocomplete.setAttribute('disabled', '');
    }
    (_c = inputRef.current.parentElement) === null || _c === void 0 ? void 0 : _c.appendChild(autocompleteElement);
    inputRef.current.style.display = 'none';
    const tryInject = () => {
        if (!injectShadowStyles(autocompleteElement)) {
            const observer = new MutationObserver(() => {
                injectShadowStyles(autocompleteElement);
                observer.disconnect();
            });
            observer.observe(autocompleteElement, { childList: true, subtree: true });
        }
    };
    tryInject();
    const trapEl = typeof document !== 'undefined' ? document.querySelector('.oneLayerOpenAnimation') : null;
    const cleanupContainingBlockFix = applyContainingBlockFix(autocompleteElement, trapEl, isMas);
    if (autocompleteRef) {
        autocompleteRef.current = autocomplete;
    }
    const handleSelect = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { placePrediction } = event;
        if (!placePrediction) {
            return logger === null || logger === void 0 ? void 0 : logger.warn('[initializeAutocomplete] No placePrediction in event.');
        }
        const { placeId } = placePrediction;
        if (placeId) {
            updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'placeId', placeId);
        }
        const inputName = (_b = (_a = placePrediction.mainText) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
        updateLocationSearchInputLocalStorage(localStorageLocationSearchInputKey, 'inputName', inputName);
        inputRef.current.value = inputName;
        syncAutocompleteElementValue(autocompleteRef.current, inputName);
        setInputValue === null || setInputValue === void 0 ? void 0 : setInputValue(inputName);
        if (autocompleteRef) {
            autocompleteRef.current = autocomplete;
        }
        const place = placePrediction.toPlace();
        try {
            yield place.fetchFields({
                fields: ['location', 'displayName', 'formattedAddress', 'location'],
            });
            const placeGeo = place.location;
            if (placeGeo) {
                setSearchedCoords({
                    latitude: placeGeo.lat(),
                    longitude: placeGeo.lng(),
                    autolocateMe: false,
                });
            }
            else {
                logger === null || logger === void 0 ? void 0 : logger.warn('[initializeAutocomplete] No location returned after fetchFields.');
            }
        }
        catch (err) {
            logger === null || logger === void 0 ? void 0 : logger.error('[initializeAutocomplete] fetchFields failed:', err);
        }
    });
    autocompleteElement.addEventListener('gmp-select', handleSelect);
    const handleInput = (event) => {
        var _a;
        const target = event.target;
        onInputValueChange === null || onInputValueChange === void 0 ? void 0 : onInputValueChange((_a = target === null || target === void 0 ? void 0 : target.value) !== null && _a !== void 0 ? _a : '');
    };
    autocomplete.addEventListener('input', handleInput);
    const parent = inputRef.current.parentElement;
    const cleanup = () => {
        autocompleteElement.removeEventListener('gmp-select', handleSelect);
        autocomplete.removeEventListener('input', handleInput);
        cleanupContainingBlockFix();
        if (parent && autocompleteElement.parentElement === parent) {
            parent.removeChild(autocompleteElement);
        }
        if (inputRef.current) {
            inputRef.current.style.display = '';
        }
    };
    return cleanup;
};
export const setLocationFilterToDefaultState = (vtpConfiguration, envConfig, clearAllDealerFilters, context, inputRef, isMas, requireMandatoryAreaSearchLocation) => {
    const scsUrlParts = getScsUrlPartsFromConfiguration(vtpConfiguration, envConfig);
    const localStorageLocationSearchInputKey = isMas
        ? `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_mandatoryLocationSearch--input`
        : `VTP_${scsUrlParts.marketPath}_locationSearch--input`;
    const localStorage = new ExpiringStorage(localStorageLocationSearchInputKey, 30);
    const { setWholeMarketDealersFetch, setRadius, setPrevSearchedCoords, setSearchedCoords } = context;
    inputRef.current.value = '';
    localStorage.clearStorage();
    setRadius(undefined);
    setPrevSearchedCoords(undefined);
    setSearchedCoords(undefined);
    clearAllDealerFilters().then(() => {
        if (isMas) {
            requireMandatoryAreaSearchLocation === null || requireMandatoryAreaSearchLocation === void 0 ? void 0 : requireMandatoryAreaSearchLocation();
        }
        setWholeMarketDealersFetch(true);
    });
};
export const extractGoogleMapsAuthParams = (queryParams) => {
    const params = new URLSearchParams(queryParams);
    return {
        googleMapsApiKey: params.get('key'),
        googleMapsClient: params.get('client'),
        googleMapsChannel: params.get('channel'),
    };
};
export const hasGeoLocation = (activeFilter) => {
    return activeFilter && activeFilter.geo;
};
export const persistLocationInput = (activeFilter, vtpConfiguration, envConfig, logger) => {
    if (typeof window === 'undefined' ||
        typeof window.google === 'undefined' ||
        typeof activeFilter === 'undefined') {
        return;
    }
    const scsUrlParts = getScsUrlPartsFromConfiguration(vtpConfiguration, envConfig);
    const enabledMandatoryAreaSearch = vtpConfiguration.enableMandatoryAreaSearch || false;
    const localStorageLocationSearchInputKey = enabledMandatoryAreaSearch
        ? `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_mandatoryLocationSearch--input`
        : `VTP_${scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath}_locationSearch--input`;
    if (window.localStorage.getItem(localStorageLocationSearchInputKey)) {
        return;
    }
    const geoData = activeFilter.geo.values;
    const latitude = geoData[0];
    const longitude = geoData[1];
    const radius = geoData[2];
    const inputName = geoData[4];
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
    geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
                const localStorage = new ExpiringStorage(localStorageLocationSearchInputKey, 30);
                const placeId = results[1].place_id;
                const storeValue = {
                    placeId,
                    inputName,
                    radius,
                };
                localStorage.writeEntry(storeValue);
            }
        }
        else {
            logger === null || logger === void 0 ? void 0 : logger.error(`Geocoder failed due to: ${status}`);
        }
    });
};
